import { queryClient } from 'configs/query';

import { base64DecToArr, base64EncArr, strToUTF8Arr, UTF8ArrToStr } from './encoder';

const NEO_KEY = 'neon';
const NEO_SRV = 'neo-server';
const NONCE_KEY = 'nonce-key';

export const setAPIServer = (value: string) => localStorage.setItem(NEO_SRV, value);
export const getAPIServer = () => localStorage.getItem(NEO_SRV);
export const isAPIUS = () => localStorage.getItem(NEO_SRV) === 'US';

const getEncodedSession = (session: string) => base64EncArr(strToUTF8Arr(session));

export const getSession = () => localStorage.getItem(NEO_KEY);
export const getNonceSession = () => localStorage.getItem(NONCE_KEY);
export const setSession = (token: string, service: string | null) => {
  const value = JSON.stringify({ token, service });
  localStorage.setItem(NEO_KEY, getEncodedSession(value));
};

export const setNonceSession = (
  token: string | null,
  signingKey: string,
  service: string | null
) => {
  const value = JSON.stringify({ token, signingKey, service });
  localStorage.setItem(NONCE_KEY, getEncodedSession(value));
};

export const removeSession = () => localStorage.removeItem(NEO_KEY);

const getDecodedSession = (session: string) => UTF8ArrToStr(base64DecToArr(session));

const QUERY_KEY = '?token=';
export const getQueryToken = () => {
  try {
    return window.location.search && window.location.search?.includes(QUERY_KEY)
      ? window.location.search.split(QUERY_KEY)[1]
      : '';
  } catch {
    return '';
  }
};

export const getToken = (authType?: string): string => {
  try {
    const session = authType === 'nonce' ? getNonceSession() : getSession();
    if (typeof session === 'string') {
      const { token } = JSON.parse(getDecodedSession(session));
      return token;
    }
    return '';
  } catch {
    return '';
  }
};

export const getService = (authType?: string) => {
  try {
    const session = authType === 'nonce' ? getNonceSession() : getSession();
    if (typeof session === 'string') {
      const { service } = JSON.parse(getDecodedSession(session));
      return service?.toString();
    }
    return '';
  } catch {
    return '';
  }
};

export const getSigningKey = () => {
  try {
    const session = getNonceSession();
    if (typeof session === 'string') {
      const { signingKey } = JSON.parse(getDecodedSession(session));
      return signingKey?.toString();
    }
    return '';
  } catch {
    return '';
  }
};

export const clearSiteStorage = () => {
  try {
    removeSession();
    localStorage.clear();
    sessionStorage.clear();
    queryClient.removeQueries();
    queryClient.clear();
    document.cookie.split(';').forEach(function (c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
    // eslint-disable-next-line no-empty
  } catch {}
};

export const clearAllCookies = () => {
  document.cookie.split(';').forEach(function (cookie) {
    const cookieName = cookie.split('=')[0].trim();
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  });
};
